<template>
	<div class="home">
		<privacyComponent />
	</div>
</template>

<script>
import privacyComponent from "@/components/client/privacyComponent.vue";
export default {
	name: "HomeView",
	components: {
		privacyComponent,
	},
};
</script>
